import { Navigate } from "react-router-dom";
import { CONFIG } from "../config";

const PublicRoute = ({ children }) => {
	const token = localStorage.getItem("token");

	if (token) {
		window.location.href = CONFIG.FRONTEND_URL;
		return null;
	}

	return children;
};

export default PublicRoute;
